import { useCallback, useMemo } from 'react';
import axios, { AxiosError } from 'axios';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import api from '@src/services/api';
import { isObjEmpty } from '@src/utility/Utils';
import { toastError, toastSuccess } from '@src/utility/Toast';
import { useLoadingGlobal } from '@src/utility/hooks/useLoadingGlobal';

import { PasswordTabContentData } from './PasswordTabContentData';

export function usePasswordTabContentForm() {
  const { showLoader, hideLoader } = useLoadingGlobal();

  const PasswordTabContentSchema = useMemo(
    () =>
      yup.object().shape({
        currentPassword: yup.string().required('Senha atual é obrigatório'),
        newPassword: yup
          .string()
          .required('Nova senha é obrigatório')
          .matches(
            /^.*(?=.{6,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
            'A senha deve conter pelo menos 6 caracteres, um maiúscula, um número e um caractere especial'
          ),
        retypeNewPassword: yup
          .string()
          .required('Por favor, confirme sua nova senha')
          .oneOf([yup.ref(`newPassword`), null], 'Senha não coincide'),
      }),
    []
  );

  const { register, errors, handleSubmit, trigger } = useForm({
    resolver: yupResolver(PasswordTabContentSchema),
  });

  const onSubmit = useCallback(
    async (formValues: PasswordTabContentData) => {
      trigger();
      if (isObjEmpty(errors)) {
        showLoader();

        try {
          const response = await api.post('password', formValues);

          hideLoader();

          toastSuccess({
            title: 'Parabéns',
            description: response.data.message,
          });
        } catch (error) {
          hideLoader();

          const err = error as Error | AxiosError;

          if (axios.isAxiosError(err)) {
            const messages = err.response?.data;

            if (typeof messages === 'object') {
              if (!Object.keys(messages).includes('message')) {
                Object.keys(messages).forEach((message) => {
                  const errors = messages[message];
                  errors.forEach((error: string) => {
                    toastError({ title: 'Atenção', description: error });
                  });
                });
              } else {
                toastError({ title: 'Atenção', description: messages.message });
              }
            } else {
              toastError({
                title: 'Atenção',
                description: 'Algo deu errado ao mudar a senha',
              });
            }
          } else {
            toastError({
              title: 'Atenção',
              description: 'Algo deu errado ao mudar a senha',
            });
          }
        }
      }
    },
    [errors, hideLoader, showLoader, trigger]
  );

  return {
    register,
    errors,
    onSubmit: handleSubmit(onSubmit),
  };
}
